import {
  Box,
  AppBar,
  Avatar,
  SvgIcon,
  Toolbar,
  IconButton,
  Typography,
} from "@mui/material";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import { Menu as MenuIcon } from "react-feather";
import { useContext } from "react";
import { AuthContext } from "../../../context/Auth";
import SVG_WEBSITE_LOGO from "../../../assets/AirtelPaymentBank.png";
import "./index.scss";

const TopBar = ({ className, onMobileNavOpen, ...rest }) => {
  const navigate = useNavigate();

  return (
    <AppBar
      elevation={0}
      color="inherit"
      className={clsx("topbar", className)}
      {...rest}
    >
      <Toolbar className="topbar__toolbar">
        <Box sx={{ display: { xs: "block", md: "none" } }}>
          <IconButton
            onClick={onMobileNavOpen}
            className="topbar__menu-icon"
          >
            <SvgIcon>
              <MenuIcon />
            </SvgIcon>
          </IconButton>
        </Box>

        <Box className="topbar__main-header">
          <Box className="topbar__logo-container">
            <IconButton
              className="topbar__logo-button"
              onClick={() => navigate("/dashboard")}
            >
              <img
                alt="Logo"
                src={SVG_WEBSITE_LOGO}
                className="topbar__logo-image"
              />
            </IconButton>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;

export function TopBarData() {
  const navigate = useNavigate();
  const auth = useContext(AuthContext);

  return (
    <Box className="topbar-data">
      <Box
        className="topbar-data__user-info"
        sx={{ display: { xs: "none", sm: "block" } }}
      >
        <Typography variant="h5" className="topbar-data__title">
          NFT Marketplace
        </Typography>
        <Typography variant="body1" className="topbar-data__email">
          example@gmail.com
        </Typography>
      </Box>

      <Avatar
        src={
          auth?.userData?.profilePic
            ? `${auth?.userData?.profilePic}`
            : "https://picsum.photos/533/357"
        }
        className="topbar-data__avatar"
      />
    </Box>
  );
}
